'use client';

import { c as _c } from "react/compiler-runtime";
import toast from '@shared/utils/helpers/toast';
import useSpace from '@shared/utils/hooks/useSpace';
import { useQueryClient } from '@tanstack/react-query';
import { client, type RouterOutputs } from '../../../utils/trpc';
type Space = RouterOutputs['spaces']['get'];
type Props = {
  spaceSlug: string;
  /** Whether the viewer is alerted to new cards on this board now. */
  enabled: boolean;
  /** Closes the menu the item sits in. */
  closeHandler: () => void;
};

// The board's subscription to new-card alerts, a row of the header's ⋮ menu
// (.specs/notifications.md → Board post alerts). Shown to members only.
const PostAlertsMenuItem = t0 => {
  const $ = _c(11);
  const {
    spaceSlug,
    enabled,
    closeHandler
  } = t0;
  const queryClient = useQueryClient();
  const {
    queryKey
  } = useSpace();
  let t1;
  if ($[0] !== closeHandler || $[1] !== enabled || $[2] !== queryClient || $[3] !== queryKey || $[4] !== spaceSlug) {
    t1 = async () => {
      closeHandler();
      const [error, result] = await client.spaces.setPostAlerts.mutate({
        slug: spaceSlug,
        enabled: !enabled
      });
      if (error) {
        toast(error.message, "", "error");
        return;
      }
      queryClient.setQueryData(queryKey, old => old?.membership ? {
        ...old,
        membership: {
          ...old.membership,
          postAlerts: result.postAlerts
        }
      } : old);
      toast(result.postAlerts ? "Alerts on" : "Alerts off", result.postAlerts ? "You will be told when someone adds a card to this board." : "You will not be told about new cards on this board.");
    };
    $[0] = closeHandler;
    $[1] = enabled;
    $[2] = queryClient;
    $[3] = queryKey;
    $[4] = spaceSlug;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const toggle = t1;
  let t2;
  if ($[6] !== toggle) {
    t2 = () => void toggle();
    $[6] = toggle;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = enabled ? "Disable alerts" : "Enable alerts";
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <button data-id="board-post-alerts" onClick={t2} className="block w-full rounded-md px-4 py-2 text-left hover:bg-background-light">{t3}</button>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default PostAlertsMenuItem;